import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService } from 'ng-jhipster';
import { ReservationPriority } from './reservation-priority.model';
import { ReservationPriorityService } from './reservation-priority.service';

@Component({
    selector: 'jhi-reservation-priority-detail',
    templateUrl: './reservation-priority-detail.component.html'
})
export class ReservationPriorityDetailComponent implements OnInit, OnDestroy {

    reservationPriority: ReservationPriority;
    private subscription: any;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private reservationPriorityService: ReservationPriorityService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['reservationPriority']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['id']);
        });
    }

    load(id) {
        this.reservationPriorityService.find(id).subscribe(reservationPriority => {
            this.reservationPriority = reservationPriority;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-priority/reservation-priority-detail.component.ts